export default {"src":"/_next/static/media/ampersand.9a2d885c.svg","height":447,"width":430,"blurWidth":0,"blurHeight":0};